module.exports = __webpack_public_path__ + "static/media/downtimedollars-logo-loading.273dea93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/downtimedollars-logo-loading.png
// module id = 359
// module chunks = 0